import Service from "../Service";
const resource = "HmnDistributionControl/";

export default {

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },
    pagination(dtr, requestID) {
        console.log("filter1",dtr);
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    listWorketActive(dtr, requestID) {
        console.log("filter2",dtr);
        return Service.post(resource + "listWorketActive", dtr, {
            params: { requestID: requestID },
        });
    },
};